export class UpdateStatisticRequest {
  botId: number;
  dateFrom: string;
  dateTo: string;
  spIds: number[];

  constructor(botId: number, dateFrom: string, dateTo: string, spIds: number[]) {
    this.botId = botId;
    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
    this.spIds = spIds;
  }
}
